import React, { Component } from "react";

class Lbg extends Component {
    render() {
        return(
            <>
            <section class="section" id="lbg">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="feature_header text-center">
                    <h3 class="feature_title"><strong>LBG Prague</strong></h3>
                    <h4 class="feature_sub">If you want to know more about our local BEST group, visit our web <a href="http://www.bestprague.cz/eng">www.bestprague.cz</a>.</h4>
                    <div class="divider"></div>
                    <div class="row">
                        <div class="col-md-8 col-md-push-2 col-xs-12">

                           <img src="images/lbg.jpg" class="img-responsive"/>
                            
                        </div>
                    </div>
                   
                    <div class="divider"></div>

                </div>
            </div>
        </div>
    </div>
</section>

            </>
        );
    }
}

export default Lbg;